export const CHECKOUT_URL = 'https://pain-en.impultienda.ar/checkout/';

export const images = {
  mockup: 'https://cdn.magicpatterns.com/uploads/njz3dLhc3V4p1jrGGLuwaj/MOCKUP_PAIN-EN.png',
  author: 'https://cdn.magicpatterns.com/uploads/3aRBut9zjNyDJRhtaTU8yt/RYAN_CARTER_-_SPINE.png',
};

export const countdownSeconds = 17 * 60 + 34;

export const scarcity = { total: 100, remaining: 7 };

export const offerIncludes = [
  'Instant digital access.',
  'All six volumes.',
  'All five specialized bonuses.',
  'Lifetime access to your purchased files.',
  'No recurring subscription.',
];
